import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import './RoomTrx.css';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';

const ConfirmPay = () => {
    const { token } = useParams();
    const decodedToken = jwtDecode(token)

    const [msg, setMsg] = useState('Tombol belum di klik');
    const [loading, setLoading] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    console.log(selectedFile)



    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!selectedFile) {
            setMsg('Pilih file terlebih dahulu!');
            return;
        }

        const maxSize = 2 * 1024 * 1024;
        if (selectedFile.size > maxSize) {
            setMsg('File size tidak boleh lebih dari 2MB');
            return;
        }

        setLoading(true);

        try {
            const formData = new FormData();
            formData.append('id', decodedToken.id);
            formData.append('amount', decodedToken.nominal);
            formData.append('bank', decodedToken.bank);
            formData.append('norek', decodedToken.norek);
            formData.append('name', decodedToken.nama);
            formData.append('emailSeller', decodedToken.emailSeller);
            formData.append('emailAdmin', decodedToken.emailAdmin);
            formData.append('image', selectedFile);

            const response = await axios.post(`${process.env.REACT_APP_URL_BACKEND}/auth/paymetToSeller`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            setLoading(false)
            setMsg(response.data.msg);
        } catch (error) {
            setLoading(false);
            setMsg(error.response.data.msg);
            console.error(error);
        } 
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setSelectedFile(file);
    };

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            height: '100vh',
            width: '100%',
        }}>
            <p style={{ color: 'black' }}>{msg}</p>
            <form onSubmit={handleSubmit}>
                <input
                    type="file"
                    onChange={handleFileChange}
                    style={{
                        color: 'black',
                        width: '90%',
                        border: '1px solid #d9d9d9',
                        borderRadius: '5px'
                    }}
                    required
                />
                <div className='modal-change'>
                    {msg === 'Berhasil Mengirim Email Pembayaran ke Penjual' ? (
                        <div></div>
                    ) : (
                        <button type="submit" disabled={loading}>
                            {loading ? <div className='spinner'></div> : 'Kirim Pembayaran'}
                        </button>
                    )}
                </div>
            </form>
        </div>
    );
};

export default ConfirmPay;
